<template>
  <div class="login-page">
    <el-card class="login-card" shadow="never">
      <h1>聚能教育后台登录</h1>
      <p>请输入管理员账号和密码</p>
      <el-alert
        v-if="errorMessage"
        class="login-alert"
        :title="errorMessage"
        type="error"
        :closable="false"
        show-icon
      />
      <el-form ref="formRef" :model="form" :rules="rules" @submit.native.prevent="submit">
        <el-form-item prop="username">
          <el-input
            v-model.trim="form.username"
            placeholder="请输入用户名"
            autocomplete="username"
            @keyup.enter.native="submit"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model.trim="form.password"
            type="password"
            placeholder="请输入密码"
            show-password
            autocomplete="current-password"
            @keyup.enter.native="submit"
          />
        </el-form-item>
        <el-button type="primary" style="width: 100%" :loading="submitting" @click="submit">
          登录
        </el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { adminLogin } from '../api/admin'
import { setAdminToken, setAdminUser } from '../utils/auth'

export default {
  data() {
    return {
      submitting: false,
      errorMessage: '',
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async submit() {
      if (this.submitting) {
        return
      }
      const valid = await new Promise(resolve => {
        this.$refs.formRef.validate(ok => resolve(ok))
      })
      if (!valid) {
        return
      }
      this.errorMessage = ''
      this.submitting = true
      try {
        const result = await adminLogin(this.form)
        setAdminToken(result.token)
        setAdminUser(result)
        this.$message.success('登录成功')
        const redirect = this.$route.query.redirect
        this.$router.replace(result.needChangePassword ? '/change-password' : (redirect || '/dashboard'))
      } catch (error) {
        this.errorMessage = (error && error.message) || '登录失败，请检查账号和密码'
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f7efe5, #f4f7fb);
}

.login-card {
  width: 420px;
  border-radius: 20px;
}

.login-alert {
  margin-bottom: 16px;
}

h1 {
  margin: 0 0 12px;
}

p {
  margin: 0 0 20px;
  color: #7c6d5d;
}
</style>
